// extracted by mini-css-extract-plugin
export default {"aboutus-container":"AboutUs_aboutus-container__t3YS4","ending-p":"AboutUs_ending-p__9nPJ8"};